(function ($) {
  DJ.addBehavior('userPicture', '.user-picture', {
    attach: function () {

    }
  });
})(jQuery);
